import type { ReactNode } from "react"
import { cn } from "@/shared/lib/cn"

/**
 * Estado vazio com icone e mensagem. Usado pela busca de rede credenciada, nos
 * dois momentos em que nao ha o que listar: antes da primeira consulta e quando
 * a consulta nao encontra unidades.
 */
export interface EmptyStateProps {
  icon: ReactNode
  children: ReactNode
  /** `true` desenha a caixa bege — usado quando o resultado veio vazio. */
  boxed?: boolean
  className?: string
}

export function EmptyState({ icon, children, boxed = false, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        "py-12 flex flex-col items-center gap-3 text-center",
        boxed && "bg-off-white rounded-2xl border border-verde-profundo/8",
        className,
      )}
    >
      <div
        className={cn(
          "w-12 h-12 rounded-xl flex items-center justify-center text-verde-profundo/20",
          boxed ? "bg-white" : "bg-off-white",
        )}
      >
        {icon}
      </div>
      <p className="text-sm text-verde-profundo/45 max-w-xs leading-relaxed">{children}</p>
    </div>
  )
}
